// extracted by mini-css-extract-plugin
module.exports = {"accent":"#16608b"};